"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// TODO: Add Types to this lib to be able to remove the ts-ignore :(
// @ts-ignore
const mark_es6_1 = __importDefault(require("mark.js/dist/mark.es6"));
(function () {
    'use strict';
    let exports = {
        attachHighlighter: () => {
            const options = {
                element: 'span',
                className: 'results-highlight'
            };
            const searchInput = document.querySelector('#searchterm');
            const initialiseMark = new mark_es6_1.default(document.querySelectorAll('div.accordion__item'));
            if (typeof (searchInput) !== 'undefined' && searchInput !== null) {
                let searchTerm = document.querySelector('#searchterm').value;
                initialiseMark.unmark({
                    done: function () {
                        initialiseMark.mark(searchTerm, options);
                    }
                });
            }
        },
        attachTrackingEvents: () => {
            const searchInput = document.querySelector('#searchterm');
            if (typeof (searchInput) !== 'undefined' && searchInput !== null) {
                searchInput.closest('form').addEventListener("submit", (event) => {
                    let data = {
                        'event': 'event',
                        'eventCategory': 'Suche FAQs',
                        'eventAction': 'Send',
                        'eventLabel': searchInput.value
                    };
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(data);
                });
            }
        },
        attachPopularityEvents: () => {
            //@ts-ignore
            let faqApiUrl = faqApiPageUrl;
            let popularityItems = Array.from(document.querySelectorAll('[data-faq-popularity-item]'));
            if (popularityItems) {
                popularityItems.forEach((item) => {
                    document.addEventListener('DOMContentLoaded', (event) => {
                        item.addEventListener("click", (event) => {
                            event.preventDefault();
                            const el = event.target;
                            let accordionItem = el.closest('[data-faq-popularity-item]');
                            if (accordionItem) {
                                let collapseElement = accordionItem.closest('.accordion__item').querySelector('[data-gs1-accordion-collapsed]');
                                if (collapseElement) {
                                    if (collapseElement.getAttribute('data-gs1-accordion-collapsed') === 'true') {
                                        let xhttp = new XMLHttpRequest();
                                        let data = new FormData();
                                        data.append('tx_gs1faq_faq[faqItem]', el.getAttribute('data-faq-popularity-item'));
                                        xhttp.open('POST', faqApiUrl, true);
                                        xhttp.send(data);
                                    }
                                }
                            }
                        }, { capture: true });
                    });
                });
            }
        }
    };
    exports.attachHighlighter();
    exports.attachTrackingEvents();
    exports.attachPopularityEvents();
})();
exports.default = {};
